<div class="card-header bg-white" *ngIf="accessService.authorized(project, 'EDIT_EXTERNAL')">

    <ng-template #authTemplate><div [innerHtml]="accessService.authReason(project, 'EDIT_EXTERNAL')"></div></ng-template>
    <button type="button" class="btn btn-primary" placement="right" containerClass="auth-tooltip"
            *ngIf="viewMode === ViewMode.VIEW"
            (click)="setMode(ViewMode.EDIT)"
            [tooltip]="authTemplate"
            [delay]="500">Bearbeiten
    </button>

    <ng-container *ngIf="viewMode === ViewMode.EDIT">
        <button type="button" class="btn btn-success" [disabled]="form.invalid" (click)="update()">Speichern</button>
        <button type="button" class="btn btn-secondary ms-2" (click)="cancelEdit()">Abbrechen</button>
    </ng-container>
</div>
<div class="card-body">
    <form [formGroup]="form">

        <h4>Anlage Projekt in MS Teams durch IT</h4>

        <table class="table table-striped table-sm">
            <thead>
            <tr>
                <th style="width: 150px">Angelegt?</th>
                <th style="width: 150px">Angelegt am</th>
                <th style="width: 250px">Angelegt von</th>
                <th>Link</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>
                    <input class="form-check-input" type="checkbox" formControlName="teams_created"
                           *ngIf="viewMode !== ViewMode.VIEW"
                           [disableControl]="!accessService.hasRights([Right.IT, Right.PMO])">
                    <span [class.text-danger]="!form.value.teams_created" *ngIf="viewMode === ViewMode.VIEW">
                        {{ form.value.teams_created | yesNo }}
                    </span>
                </td>
                <td>
                    {{ form.value.teams_created_at | date: 'dd.MM.yyyy' }}
                </td>
                <td>
                    {{ form.value.teams_creator }}
                </td>
                <td>
                    <input type="text" class="form-control" formControlName="teams_comment"
                           *ngIf="viewMode !== ViewMode.VIEW"
                           [disableControl]="!accessService.hasRights([Right.IT, Right.PMO])">
                    <span *ngIf="viewMode === ViewMode.VIEW">
                        <a [href]="form.value.teams_comment" target="_blank">{{ form.value.teams_comment }}</a>
                    </span>
                </td>
            </tr>
            </tbody>
        </table>

        <h4>Anlage Projekt in Projektmodul D365 durch Finanzabteilung</h4>

        <table class="table table-striped table-sm">
            <thead>
            <tr>
                <th style="width: 150px">Angelegt?</th>
                <th style="width: 150px">Angelegt am</th>
                <th style="width: 250px">Angelegt von</th>
                <th>Kommentar</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>
                    <input class="form-check-input" type="checkbox" formControlName="dynamics_created"
                           *ngIf="viewMode !== ViewMode.VIEW"
                           [disableControl]="!accessService.hasRights([Right.FINANCE, Right.PMO])">
                    <span [class.text-danger]="!form.value.dynamics_created" *ngIf="viewMode === ViewMode.VIEW">
                        {{ form.value.dynamics_created | yesNo }}
                    </span>
                </td>
                <td>
                    {{ form.value.dynamics_created_at | date: 'dd.MM.yyyy' }}
                </td>
                <td>
                    {{ form.value.dynamics_creator }}
                </td>
                <td>
                    <input type="text" class="form-control" formControlName="dynamics_comment"
                           *ngIf="viewMode !== ViewMode.VIEW"
                           [disableControl]="!accessService.hasRights([Right.FINANCE, Right.PMO])">
                    <span *ngIf="viewMode === ViewMode.VIEW">
                        {{ form.value.dynamics_comment }}
                        <span class="text-muted" *ngIf="!form.value.dynamics_comment">Nicht eingetragen</span>
                    </span>
                </td>
            </tr>
            </tbody>
        </table>

        <div class="row">
            <div class="col">
                <div class="mb-2">
                    <label>Kostenstelle</label>
                    <input type="text" class="form-control" formControlName="cost_centre"
                           *ngIf="viewMode !== ViewMode.VIEW"
                           [disableControl]="!accessService.hasRights([Right.FINANCE, Right.PMO])">
                    <p *ngIf="viewMode === ViewMode.VIEW">
                        {{ form.value.cost_centre }}
                        <span class="text-danger" *ngIf="!form.value.cost_centre">Nicht eingetragen</span>
                    </p>
                </div>
            </div>
            <div class="col">
                <div class="mb-2">
                    <label>Projektart</label>
                    <select class="form-control" formControlName="cost_type"
                            *ngIf="viewMode !== ViewMode.VIEW"
                            [disableControl]="!accessService.hasRights([Right.FINANCE, Right.PMO])">
                        <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                        <option value="investment">Investitionsprojekt</option>
                        <option value="expenses">Aufwandprojekt</option>
                    </select>
                    <p *ngIf="viewMode === ViewMode.VIEW">
                        {{ form.value.cost_type | projectType }}
                        <span class="text-danger" *ngIf="!form.value.cost_type">Nicht eingetragen</span>
                    </p>
                </div>
            </div>
        </div>
    </form>
</div>
